import styled from 'styled-components'
import { setVh } from '../../styles/utils/conversion.style'
import { zIndex } from '../../styles/vars/zIndex.style'
import { easings } from '../../styles/vars/easings.style'

export const TransitionMaskWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: ${props => (props.show ? 'auto' : 'none')};
  z-index: ${zIndex.pageTransitionMask};
`

export const TransitionMaskBlock = styled.div`
  position: relative;
  width: 100%;
  ${setVh('height', 100)}
  z-index: 1;
  background-color: ${props => props.backgroundColor};
`

export const TransitionMaskIcon = styled.div`
  height: 13rem;
  left: 50%;
  margin-left: -6.5rem;
  margin-top: -6.5rem;
  position: fixed;
  top: 50%;
  width: 13rem;
  z-index: 2;
`

export const TransitionMaskLogo = styled.div`
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);

  svg {
    transform: translateY(${props => (props.show ? `0%` : `100%`)});
    transition: transform
      ${props =>
        props.show ? `1s ${easings.out.quart}` : `.3s ${easings.in.quart}`};
  }
`

export const TransitionMaskCircle = styled.div`
  transform: rotateZ(-90deg);

  circle {
    stroke-dashoffset: 402px;

    ${props =>
      props.show &&
      `
      animation: load 4s ${easings.inOut.quart} 0s infinite;
      opacity: ${props.show ? 1 : 0};
    `}
  }

  @keyframes load {
    from {
      stroke-dashoffset: 402px;
    }
    to {
      stroke-dashoffset: -402px;
    }
  }
`
